import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Button from "components/Button";
import useLanguageProvider from "components/LanguageProvider/hooks/useLanguageProvider";
import CampaignUpdateTile from "../CampaignUpdateTile/CampaignUpdateTile";
import "./_style.scss";
const CampaignUpdates = ({ updates, campaign, fetchMore, loading, hasNextPage, isCommentsEnabled = true, }) => {
    const { translate: t } = useLanguageProvider();
    if (loading) {
        return _jsx("div", { children: "Loading..." });
    }
    return (_jsxs("div", { className: "campaign-updates__grid-layout", children: [updates.map((update) => (_jsx(CampaignUpdateTile, { update: update, campaign: campaign, isCommentsEnabled: isCommentsEnabled }, `update-tile-${update.id}`))), hasNextPage && (_jsx("div", { className: "campaign-updates__view-more-button-container", children: _jsx(Button, { onClick: fetchMore, className: "link-button", look: "normal", isRounded: true, "data-testid": "view-more-updates-button", isDisabled: loading, isLoading: loading, children: t("View more updates") }) }))] }));
};
export default CampaignUpdates;
